/**
 * ObjectMediaField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import InputLabel from '@material-ui/core/InputLabel';

// application components
import ObjectGrid from "../listing/ObjectGrid";

// application
import {selectReference, pushAndEditObject} from "../../operations/editing";
import {removeFieldElementAction, moveFieldElementAction} from "../../redux/editing/actions";
import {searchTag} from "../../operations/listing";
import {openMediaOverlayForObject} from "../../operations/view";
import {selectObjectsForIds} from "../../redux/editing/selectors";
import {parseBSON} from '../../utils';
import FormHelperText from "@material-ui/core/FormHelperText";


/**
 * ObjectMediaField is an editing component for media fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectMediaField extends React.Component {

    handleAddReference = (id, constraint, flags) => event => {
        const scope = this.props.scope || [];
        this.props.selectReference([...scope, id], "mediaitem", constraint, flags);
    };

    render() {

        const { fieldDef, classes } = this.props;

        const scope = this.props.scope || [];
        const limit = fieldDef.quantity === 'single' ? 1 : (Number.isInteger(fieldDef.quantity) && fieldDef.quantity);
        const fullyOccupied  = limit && this.props.fieldItems.length >= limit;
        const selectionConstraint = parseBSON(fieldDef.refconstraint, undefined, fieldDef.id);
        const selectionFlags = {
            replace: fullyOccupied,
            preference: this.props.fieldDef.preference || "selection",
            scope: this.props.scope
        };

        const standardHandlers = {
            onSelect: (index, object) => this.props.openMediaOverlayForObject(object),
            onEdit: (index, object) => this.props.pushAndEditObject(object.id, this.props.readOnly),
            onRemove: (index, object) => this.props.removeFieldElementAction(this.props.objectId, [...scope, fieldDef.id], index),
            onSearchTag: this.props.searchTag
        };
        const addHandlers = !fullyOccupied ? {
            onAdd: this.handleAddReference(fieldDef.id, selectionConstraint, selectionFlags),
            onDuplicate: (index, item) => this.props.addElement([...scope, fieldDef.id], item.type, item.fields)
        } : {};
        const listHandlers = limit !== 1 ? {
            onMoveToFront: (index) => this.props.moveFieldElementAction(this.props.objectId, [...scope, fieldDef.id], index, 0)
        } : {};
        const handlers = {
            ...standardHandlers,
            ...addHandlers,
            ...listHandlers
        };

        return <div className={classes.mediaField}>
            <InputLabel>{fieldDef.name}</InputLabel>
            <FormHelperText style={{position:"relative", top:"-3px"}}>{fieldDef.note}</FormHelperText>
            <ObjectGrid
                items={this.props.fieldItems}
                readOnly={this.props.readOnly}
                id={fieldDef.id}
                label={fieldDef.name}
                {...handlers}
                pagination={false}
            />
        </div>;
    }
}

ObjectMediaField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    mediaField: {
        marginTop: 16
    }
};

const mapStateToProps = (state, props) => {
    return {
        fieldItems: selectObjectsForIds(state.editing, props.value),
    };
};

export default connect(mapStateToProps, {
    selectReference, pushAndEditObject, removeFieldElementAction, moveFieldElementAction,
    searchTag, openMediaOverlayForObject
})(withStyles(styles)(ObjectMediaField));